import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { plus1ogy4liedzq5j as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ListClass;
function List() {
  if (ListClass === VOID) {
    class $ extends State() {
      constructor(list) {
        super();
        this.y4c_1 = list;
      }
      toString() {
        return 'List (' + this.y4c_1.q2() + ')';
      }
    }
    initMetadataForClass($, 'List');
    ListClass = $;
  }
  return ListClass;
}
var MapClass;
function Map() {
  if (MapClass === VOID) {
    class $ extends State() {
      constructor(map, name) {
        super();
        this.z4c_1 = map;
        this.a4d_1 = name;
      }
      toString() {
        return 'Map (' + this.a4d_1 + ')';
      }
    }
    initMetadataForClass($, 'Map');
    MapClass = $;
  }
  return MapClass;
}
var StateClass;
function State() {
  if (StateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'State');
    StateClass = $;
  }
  return StateClass;
}
function mergeWith($this, $receiver, other) {
  if ($receiver == null) {
    return other;
  }
  if (other == null) {
    return $receiver;
  }
  var tmp;
  if (isInterface($receiver, KtList())) {
    // Inline function 'kotlin.check' call
    if (!isInterface(other, KtList())) {
      var message = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!($receiver.q2() === other.q2())) {
      var message_0 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
      throw IllegalStateException().o(toString(message_0));
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices($receiver);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.q3_1;
    var last = this_0.r3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var i = item;
        var tmp$ret$6 = mergeWith($this, $receiver.r2(i), other.r2(i));
        destination.i2(tmp$ret$6);
      }
       while (!(item === last));
    tmp = destination;
  } else {
    if (isInterface($receiver, KtMap())) {
      // Inline function 'kotlin.check' call
      if (!isInterface(other, KtMap())) {
        var message_1 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().o(toString(message_1));
      }
      if (!isInterface($receiver, KtMap()))
        THROW_CCE();
      if (!isInterface(other, KtMap()))
        THROW_CCE();
      // Inline function 'kotlin.collections.map' call
      var this_1 = plus($receiver.v4(), other.v4());
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().h2(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s = this_1.p1();
      while (_iterator__ex2g4s.q1()) {
        var item_0 = _iterator__ex2g4s.r1();
        var tmp$ret$11 = to(item_0, mergeWith($this, $receiver.u4(item_0), other.u4(item_0)));
        destination_0.i2(tmp$ret$11);
      }
      tmp = toMap(destination_0);
    } else {
      // Inline function 'kotlin.check' call
      if (!equals($receiver, other)) {
        // Inline function 'kotlin.error' call
        var message_2 = 'Cannot merge ' + toString($receiver) + ' with ' + toString(other);
        throw IllegalStateException().o(toString(message_2));
      }
      tmp = $receiver;
    }
  }
  return tmp;
}
function valueInternal($this, value) {
  // Inline function 'kotlin.apply' call
  var state = lastOrNull($this.a41_1);
  if (state instanceof Map()) {
    var name = state.a4d_1;
    // Inline function 'kotlin.check' call
    if (!!(name == null)) {
      throw IllegalStateException().o('Check failed.');
    }
    if (state.z4c_1.s4(name)) {
      var tmp0 = state.z4c_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = mergeWith($this, state.z4c_1.u4(name), value);
      tmp0.x4(name, value_0);
    } else {
      // Inline function 'kotlin.collections.set' call
      state.z4c_1.x4(name, value);
    }
    state.a4d_1 = null;
  } else {
    if (state instanceof List()) {
      state.y4c_1.i2(value);
    } else {
      $this.y40_1 = value;
      $this.z40_1 = true;
    }
  }
  return $this;
}
var MapJsonWriterClass;
function MapJsonWriter() {
  if (MapJsonWriterClass === VOID) {
    class $ {
      constructor() {
        this.y40_1 = null;
        this.z40_1 = false;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.a41_1 = ArrayList().p2();
      }
      i41() {
        // Inline function 'kotlin.check' call
        if (!this.z40_1) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.y40_1;
      }
      k41() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().p2();
        this.a41_1.i2(new (List())(list));
        return this;
      }
      l41() {
        // Inline function 'kotlin.apply' call
        var state = this.a41_1.c5(this.a41_1.q2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof List())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.y4c_1);
        return this;
      }
      f41() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableMapOf' call
        var map = LinkedHashMap().bc();
        this.a41_1.i2(new (Map())(map, null));
        return this;
      }
      g41() {
        // Inline function 'kotlin.apply' call
        var state = this.a41_1.c5(this.a41_1.q2() - 1 | 0);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        valueInternal(this, state.z4c_1);
        return this;
      }
      h48(name) {
        // Inline function 'kotlin.apply' call
        var state = last(this.a41_1);
        // Inline function 'kotlin.check' call
        if (!(state instanceof Map())) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!(state.a4d_1 == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        state.a4d_1 = name;
        return this;
      }
      m4a() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.a41_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp;
          if (item instanceof List()) {
            tmp = item.y4c_1.q2().toString();
          } else {
            if (item instanceof Map()) {
              var tmp1_elvis_lhs = item.a4d_1;
              tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
            } else {
              noWhenBranchMatchedException();
            }
          }
          var tmp$ret$2 = tmp;
          destination.i2(tmp$ret$2);
        }
        return joinToString(destination, '.');
      }
      r41(value) {
        return valueInternal(this, value);
      }
      b42(value) {
        return valueInternal(this, value);
      }
      w41(value) {
        return valueInternal(this, value);
      }
      t41(value) {
        return valueInternal(this, value);
      }
      z41(value) {
        return valueInternal(this, value);
      }
      x4a(value) {
        return valueInternal(this, value);
      }
      g42(value) {
        return valueInternal(this, null);
      }
      b41(value) {
        return valueInternal(this, value);
      }
      k40() {
        return valueInternal(this, null);
      }
      l6() {
      }
    }
    initMetadataForClass($, 'MapJsonWriter', MapJsonWriter);
    MapJsonWriterClass = $;
  }
  return MapJsonWriterClass;
}
//region block: exports
export {
  MapJsonWriter as MapJsonWriter4jz7ym6vbwk4,
};
//endregion

//# sourceMappingURL=MapJsonWriter.mjs.map
